.backdrop {
  position: fixed;
  inset: 0;
  z-index: var(--z-drawer);
  display: flex;
  background-color: var(--color-overlay);
  animation: backdrop-in var(--duration-normal) var(--ease-out);
}

.panel {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: var(--color-surface-raised);
  box-shadow: var(--shadow-xl);
}

.panel:focus-visible {
  outline: none;
}

.right {
  margin-left: auto;
  border-left: 1px solid var(--color-border);
  animation: slide-in-right var(--duration-slow) var(--ease-out);
}

.left {
  margin-right: auto;
  border-right: 1px solid var(--color-border);
  animation: slide-in-left var(--duration-slow) var(--ease-out);
}

.sm {
  max-width: 22rem;
}

.md {
  max-width: 28rem;
}

.lg {
  max-width: 40rem;
}

.xl {
  max-width: 56rem;
}

.header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--space-3);
  padding: var(--space-5);
  border-bottom: 1px solid var(--color-border);
}

.headings {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  min-width: 0;
}

.title {
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-semibold);
}

.description {
  color: var(--color-text-muted);
  font-size: var(--font-size-sm);
}

.close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 2rem;
  height: 2rem;
  border-radius: var(--radius-md);
  color: var(--color-text-muted);
}

.close:hover {
  background-color: var(--color-surface-hover);
  color: var(--color-text);
}

.closeIcon {
  transform: rotate(45deg);
}

.body {
  flex: 1 1 auto;
  min-height: 0;
  padding: var(--space-5);
  overflow-y: auto;
}

.footer {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: var(--space-2);
  padding: var(--space-3) var(--space-5);
  border-top: 1px solid var(--color-border);
  background-color: var(--color-surface-sunken);
}

@keyframes backdrop-in {
  from {
    opacity: 0;
  }
}

@keyframes slide-in-right {
  from {
    transform: translateX(24px);
    opacity: 0;
  }
}

@keyframes slide-in-left {
  from {
    transform: translateX(-24px);
    opacity: 0;
  }
}
